import Joi from 'joi';
import { rutValidation } from '../../../../helpers/RutValidator';

export const schema = Joi.object({
  rut: rutValidation.rut().validateRut(),
  codeClubes: Joi.string()
    .min(9)
    .max(9)
    .pattern(new RegExp(/^\d+$/))
    .error(new Error('El número debe contener 9 dígitos.')),
});
